import {
    CUSTOM_FILED_IN_SETTING,
    CYCLE,
    INCLUDED_LOCATION_OPTIONS, PS_ON_GRID,
    RUSH_1_HOUR_NAME,
    RUSH_3_HOUR_NAME,
    SORT_PATH_FILL_ALGORITHMS,
    SORT_PATH_PICK_ALGORITHMS, SSD,
    SSD3_CYCLE,
    SSD3_LOCATION_REGEX,
    SSD3_NAME,
    SSD_AMBIENT, SSD_AMBIENT_OV,
    SSD_CHILLED, SSD_CHILLED_OV,
    SSD_CYCLE,
    SSD_FROZEN, SSD_FROZEN_OV,
    SSD_NAME,
    SSD_RUSH_1H_LOCATION_REGEX,
} from "../../../Constants";
import {
    commaSeperatedStringToArray,
    isAmxlStation,
} from "../../../Utility";
import {chainWalk} from "../CommonUtils";


export const validateCustomSettingForResource = (resourceSequences) => {
    return (Object.keys(resourceSequences || {}).length >= 1 &&
        Object.values(resourceSequences || {}).filter(x => x[0] === CUSTOM_FILED_IN_SETTING).every(x => x[1] && (x[1]).trim().length > 0));
};

const validateResourceSequenceBasedOnFillFormAlgorithm = (fillFormData) => {
    return ((fillFormData.algorithm === SORT_PATH_FILL_ALGORITHMS.STANDARD && fillFormData.resourceSequences.clusterSequence &&
        fillFormData.resourceSequences.clusterSequence[0]) ||
        (fillFormData.algorithm === SORT_PATH_FILL_ALGORITHMS.STANDARD_BLOCK && fillFormData.resourceSequences.clusterSequence &&
            fillFormData.resourceSequences.clusterSequence[0]) ||
        (fillFormData.algorithm === SORT_PATH_FILL_ALGORITHMS.CLUSTER_WISE_STANDARD && fillFormData.resourceSequences.clusterSequence &&
            fillFormData.resourceSequences.clusterSequence[0]) ||
        (fillFormData.algorithm === SORT_PATH_FILL_ALGORITHMS.FLOOR_LOCATION_STANDARD_FILL_PATH && fillFormData.resourceSequences.clusterSequence &&
            fillFormData.resourceSequences.clusterSequence[0]) ||
        (fillFormData.algorithm === SORT_PATH_FILL_ALGORITHMS.COMBINATRIX && fillFormData.resourceSequences.fingerSequence &&
            fillFormData.resourceSequences.fingerSequence[0]))
};

export const validatePickPathPattern = (pickFormData) => {
    return (pickFormData.algorithm && pickFormData.resourceSequences && pickFormData.resourceSequences.clusterSequence &&
        pickFormData.resourceSequences.clusterSequence[0]);
};

export const validateColumnLengthForPartialColumnZebraType = (pickFormData) => {
    return pickFormData.algorithm && (pickFormData.algorithm !== SORT_PATH_PICK_ALGORITHMS.PARTIAL_COLUMN_ZEBRA_PATTERN ||
        (pickFormData.algorithm === SORT_PATH_PICK_ALGORITHMS.PARTIAL_COLUMN_ZEBRA_PATTERN && pickFormData.parameters
            && pickFormData.parameters.columnLengthForZebraPath));
}

export const validateMaxClusterProximitySettings = (fillFormData) => {
    if (fillFormData.commonParameters
        && (Object.keys(fillFormData.commonParameters.maxClusterCapacityForNode || {}).length > 0)) {
        return Object.values(fillFormData.commonParameters.maxClusterCapacityForNode || {}).every(x => x <= 100);
    }
    return true;
};

export const validateClusterSequenceForNodeSettings = (
    fillFormData,
    resourceSequences,
    clusterResources
)=> {
    // 1. Check for custom sequence presence
    const hasResourceSequences = resourceSequences && Object.keys(resourceSequences).length >= 1;
    const hasCustomSequence = hasResourceSequences &&
        Object.values(resourceSequences).some(([type]) => type === CUSTOM_FILED_IN_SETTING);

    // 2. Early return if no custom sequence
    if (!hasCustomSequence) {
        return true;
    }

    // 3. Extract cluster sequence capacities
    const clusterSequenceCapacities = fillFormData.commonParameters &&
    fillFormData.commonParameters.clusterSequenceForNode
        ? fillFormData.commonParameters.clusterSequenceForNode
        : {};

    // 4. Validate all resource capacities
    const isValid = clusterResources.every(({ label }) => {
        const value = clusterSequenceCapacities[label];
        const isValueFilled = value !== null &&
            value !== undefined &&
            value.toString().trim().length > 0;
        return isValueFilled;
    });

    return isValid;
};

export const validateAdtaClusterIdentifierSettings = (fillFormData) => {
    if (fillFormData.commonParameters
        && (Object.keys(fillFormData.commonParameters.adtaClusterIdentifierForNode || {}).length > 0)) {
        return Object.values(fillFormData.commonParameters.adtaClusterIdentifierForNode || {}).every(x => x==='true' ||x==='false');
    }
    return true;
};

// Non-AMXL (AMZL) sideline zone names: e.g. S-1.1A, S1.2B, S1-3C, S1.4D
const AMZL_SIDELINE_ZONE_REGEX = /^(S-?1[-.][1-4][A-D])$/;

// Valid AMXL SIDELINE zone names: S1.MON, S1-MON, S1.TUE, ... S1.7PL, S1-7PL
const AMXL_SIDELINE_ZONE_REGEX = /^S1[.-](MON|TUE|WED|THU|FRI|SAT|SUN|7PL)$/;

// Valid AMXL SIDELINE_STATIC zone name: S1.PRD or S1-PRD
const AMXL_SIDELINE_STATIC_ZONE_REGEX = /^S1[.-]PRD$/;

/**
 * Sideline sort-zone validation rules keyed by (cycleType, stationType). Register a
 * new entry to support a new station/cycle instead of branching in the shared
 * validators or the form. Fields: isValidCount, zoneRegex, missingCountMessageId,
 * nomenclatureMessageId, duplicateMessageId, and optional sequenceInfoMessageId.
 */
const DUPLICATE_ZONE_MESSAGE_ID = "sortPaths.duplicateIncludedSortZonesTipMessage";

export const SIDELINE_ZONE_VALIDATION_RULES = {
    [CYCLE.SIDELINE]: {
        AMXL: {
            isValidCount: (count) => count === 8,
            zoneRegex: AMXL_SIDELINE_ZONE_REGEX,
            missingCountMessageId: "sortPaths.missingIncludedSortZonesAmxlSidelineTipMessage",
            nomenclatureMessageId: "sortPaths.incorrectIncludedSortZonesAmxlSidelineTipMessage",
            duplicateMessageId: DUPLICATE_ZONE_MESSAGE_ID,
            // Day-ordered buckets (1=Mon..7=Sun, 8=>7-day): show the order-info banner.
            sequenceInfoMessageId: "sortPaths.sidelineSequenceInfoBanner",
        },
        DEFAULT: {
            isValidCount: (count) => count >= 1 && count <= 4,
            zoneRegex: AMZL_SIDELINE_ZONE_REGEX,
            missingCountMessageId: "sortPaths.missingIncludedSortZonesTipMessage",
            nomenclatureMessageId: "sortPaths.incorrectIncludedSortZonesTipMessage",
            duplicateMessageId: DUPLICATE_ZONE_MESSAGE_ID,
        },
    },
    [CYCLE.SIDELINE_STATIC]: {
        AMXL: {
            isValidCount: (count) => count === 1,
            zoneRegex: AMXL_SIDELINE_STATIC_ZONE_REGEX,
            missingCountMessageId: "sortPaths.missingIncludedSortZonesSidelineStaticTipMessage",
            nomenclatureMessageId: "sortPaths.incorrectIncludedSortZonesSidelineStaticTipMessage",
            duplicateMessageId: DUPLICATE_ZONE_MESSAGE_ID,
        },
        DEFAULT: {
            isValidCount: (count) => count === 1,
            // SIDELINE_STATIC uses S1.PRD for all networks, so DEFAULT reuses the static regex.
            zoneRegex: AMXL_SIDELINE_STATIC_ZONE_REGEX,
            missingCountMessageId: "sortPaths.missingIncludedSortZonesSidelineStaticTipMessage",
            nomenclatureMessageId: "sortPaths.incorrectIncludedSortZonesSidelineStaticTipMessage",
            duplicateMessageId: DUPLICATE_ZONE_MESSAGE_ID,
        },
    },
};

/**
 * Resolves the sideline rule for a cycle + station, falling back to SIDELINE for
 * cycles without a dedicated entry, then picking the AMXL or DEFAULT variant.
 */
export const getSidelineZoneValidationRule = (cycle, nodeId) => {
    const cycleRules = SIDELINE_ZONE_VALIDATION_RULES[cycle] || SIDELINE_ZONE_VALIDATION_RULES[CYCLE.SIDELINE];
    return isAmxlStation(nodeId) ? cycleRules.AMXL : cycleRules.DEFAULT;
};

/**
 * Like getSidelineZoneValidationRule but without the SIDELINE fallback: returns a
 * rule only for cycles with a dedicated registry entry (undefined otherwise), so
 * non-sideline cycles never inherit sideline-only hints like sequenceInfoMessageId.
 */
export const getRegisteredSidelineZoneRule = (cycle, nodeId) =>
    SIDELINE_ZONE_VALIDATION_RULES[cycle] ? getSidelineZoneValidationRule(cycle, nodeId) : undefined;

const getNonEmptySortZones = (commonFormData) => (commaSeperatedStringToArray(
    chainWalk(() => commonFormData.includedLocations.includedSortZones, null)
) || []).filter(x => x && x.trim().length > 0);

const hasIncludedSortZones = (commonFormData) => !!(commonFormData.includedLocations
    && commonFormData.includedLocations.includedSortZones);

/** Validates the sideline sort-zone count via the (cycle, station) rule. */
export const validateSidelineSortZonesCount = (commonFormData) => {
    const rule = getSidelineZoneValidationRule(commonFormData.cycle, commonFormData.nodeId);
    const zones = getNonEmptySortZones(commonFormData);
    if (!hasIncludedSortZones(commonFormData) || zones.length === 0) {
        return false;
    }
    return rule.isValidCount(zones.length);
};

export const validateIncludedSortZonesForPSOnGrid = (commonFormData) => {
    return !!(commonFormData.includedLocations && commonFormData.includedLocations.includedSortZones
        && (commaSeperatedStringToArray(chainWalk(() => commonFormData.includedLocations.includedSortZones, null)).length >= 0));
};

/*
Validate if included sort zones are in the correct format for reverse cycle
*/
export const validateIncludedSortZonesForReverseCycle = (commonFormData) => {
    return !!(commonFormData.includedLocations && commonFormData.includedLocations.includedSortZones
        && (commaSeperatedStringToArray(chainWalk(() => commonFormData.includedLocations.includedSortZones, null)).length >= 0));
};

/** Validates sideline sort-zone nomenclature via the (cycle, station) rule regex. */
export const validateSidelineSortZonesNomenclature = (commonFormData) => {
    const rule = getSidelineZoneValidationRule(commonFormData.cycle, commonFormData.nodeId);
    const zones = getNonEmptySortZones(commonFormData);
    if (!hasIncludedSortZones(commonFormData) || zones.length === 0) {
        return false;
    }
    return zones.every(x => rule.zoneRegex.test(x));
};

/** Validates sideline sort zones are unique; duplicates would map to the same location. */
export const validateSidelineSortZonesUnique = (commonFormData) => {
    const zones = getNonEmptySortZones(commonFormData);
    return new Set(zones).size === zones.length;
};

export const validateCommonFormDataForPSOnGridInSSD = (commonFormData) => {
    const regex = /^(Z\.L[0-9][0-9]\.OV):(Z\.L[0-9][0-9]\.OV)$/;

    return ((commonFormData.cycle === SSD3_CYCLE && (commonFormData.name === SSD || commonFormData.name === PS_ON_GRID)  &&
            commonFormData.includedLocations && commonFormData.includedLocations.sortLocationsRange) &&
        (commonFormData.includedLocations.sortLocationsRange[0] === INCLUDED_LOCATION_OPTIONS.SORT_LOCATIONS.USE_ALL ||
            (commonFormData.includedLocations.sortLocationsRange[0] === INCLUDED_LOCATION_OPTIONS.COMMON.CUSTOM &&
                (commaSeperatedStringToArray(chainWalk(() => commonFormData.includedLocations.sortLocationsRange[1], null))
                    .every(x => regex.test(x)))))
    )
};

export const validateCommonFormDataForSSD3 = (commonFormData) => {
    const regex = SSD3_LOCATION_REGEX

    return ((commonFormData.cycle === SSD3_CYCLE && commonFormData.name === SSD3_NAME  &&
            commonFormData.includedLocations && commonFormData.includedLocations.sortLocationsRange) &&
            (commonFormData.includedLocations.sortLocationsRange[0] === INCLUDED_LOCATION_OPTIONS.SORT_LOCATIONS.USE_ALL ||
            (commonFormData.includedLocations.sortLocationsRange[0] === INCLUDED_LOCATION_OPTIONS.COMMON.CUSTOM &&
                (commaSeperatedStringToArray(chainWalk(() => commonFormData.includedLocations.sortLocationsRange[1], null))
                    .every(x => regex.test(x)))))
    )
};

// 3 Hour Rush Sort Paths use the same locations as SSD3 but do not allow Use All Feature
export const validateCommonFormDataForSSD3Rush3H = (commonFormData) => {
    const regex = SSD3_LOCATION_REGEX
    const includedLocationsRange = commaSeperatedStringToArray(chainWalk(() => commonFormData.includedLocations.sortLocationsRange[1], null))

    return ((commonFormData.cycle === SSD3_CYCLE && isValidSSDRush3HName(commonFormData.name)  &&
            commonFormData.includedLocations && commonFormData.includedLocations.sortLocationsRange) &&
            (commonFormData.includedLocations.sortLocationsRange[0] === INCLUDED_LOCATION_OPTIONS.COMMON.CUSTOM &&
                (includedLocationsRange.length > 0 && includedLocationsRange.every(x => regex.test(x))))
    )
};

export const validateCommonFormDataForSSDGrocery = (commonFormData) => {
    return ((isValidSSDGroceryCycle(commonFormData.cycle) && isValidSSDGroceryName(commonFormData.name)
            && commonFormData.additionalParams && commonFormData.additionalParams.temperature &&
            commonFormData.includedLocations && commonFormData.includedLocations.sortLocationsRange) &&
        (commonFormData.includedLocations.sortLocationsRange[0] === INCLUDED_LOCATION_OPTIONS.SORT_LOCATIONS.USE_ALL));
};

export const validateCommonFormDataForSSDRush = (commonFormData) => {
    const regex = SSD_RUSH_1H_LOCATION_REGEX
    const includedLocationsRange = commaSeperatedStringToArray(chainWalk(() => commonFormData.includedLocations.sortLocationsRange[1], null))
    return ((isValidSSDCycle(commonFormData.cycle) && isValidSSDRushName(commonFormData.name)
            && commonFormData.includedLocations && commonFormData.includedLocations.sortLocationsRange) 
            && (commonFormData.includedLocations.sortLocationsRange[0] === INCLUDED_LOCATION_OPTIONS.COMMON.CUSTOM) 
            && (includedLocationsRange.length > 0 && includedLocationsRange.every(x => regex.test(x))));
};

export const isValidSSDGroceryCycle = (cycle) => {
    return cycle === SSD3_CYCLE;
}

export const isValidSSDGroceryName = (name) => {
    return name === SSD3_NAME || name === SSD_AMBIENT || name === SSD_CHILLED || name === SSD_FROZEN
        || name === SSD_AMBIENT_OV || name === SSD_CHILLED_OV || name === SSD_FROZEN_OV;
}

export const isValidSSDRushName = (name) => {
    return name === SSD_NAME || name === RUSH_1_HOUR_NAME;
}

export const isValidSSDRush3HName = (name) => {
    return name === SSD_NAME || name === RUSH_3_HOUR_NAME;
}

export const isValidSSDCycle = (cycle) => {
    return cycle === SSD_CYCLE;
}

export const validateFillFormDataForSSD3 = (fillFormData) => {
    return (fillFormData.algorithm === SORT_PATH_FILL_ALGORITHMS.SAME_DAY_STANDARD_FILL && fillFormData.resourceSequences &&
            fillFormData.resourceSequences.sortLocationSequence)
};

export const validatePickFormDataForSSD3 = (pickFormData) => {
    return (pickFormData.algorithm === SORT_PATH_PICK_ALGORITHMS.SAME_DAY_STANDARD_PATH && pickFormData.resourceSequences &&
            pickFormData.resourceSequences.sortLocationSequence)
};

export const validateFillFormDataForPSOnGrid = (fillFormData) => {
    return (fillFormData.algorithm === SORT_PATH_FILL_ALGORITHMS.SAME_DAY_STANDARD_FILL && fillFormData.resourceSequences &&
        fillFormData.resourceSequences.sortLocationSequence)
};

export const validatePickFormDataForPSOnGrid = (pickFormData) => {
    return (pickFormData.algorithm === SORT_PATH_PICK_ALGORITHMS.SAME_DAY_STANDARD_PATH && pickFormData.resourceSequences &&
        pickFormData.resourceSequences.sortLocationSequence)
};

export const validateFillFormDataForSSDGrocery = (fillFormData) => {
    return (fillFormData.algorithm === SORT_PATH_FILL_ALGORITHMS.SAME_DAY_STANDARD_FILL && fillFormData.resourceSequences &&
        fillFormData.resourceSequences.sortLocationSequence)
};

export const validatePickFormDataForSSDGrocery = (pickFormData) => {
    return (pickFormData.algorithm === SORT_PATH_PICK_ALGORITHMS.SAME_DAY_STANDARD_PATH && pickFormData.resourceSequences &&
        pickFormData.resourceSequences.sortLocationSequence)
};

export const validateFillFormAlgorithm = (fillFormData) => {
    return ((fillFormData.algorithm === SORT_PATH_FILL_ALGORITHMS.STANDARD && Object.keys(fillFormData.parameters || {}).length === 0) ||
            (fillFormData.algorithm === SORT_PATH_FILL_ALGORITHMS.STANDARD_BLOCK && Object.keys(fillFormData.parameters || {}).length === 0) ||
            (fillFormData.algorithm === SORT_PATH_FILL_ALGORITHMS.COMBINATRIX && Object.keys(fillFormData.parameters || {}).length === 1) ||
            (fillFormData.algorithm === SORT_PATH_FILL_ALGORITHMS.FLOOR_LOCATION_STANDARD_FILL_PATH && Object.keys(fillFormData.parameters || {}).length === 0) ||
            (fillFormData.algorithm === SORT_PATH_FILL_ALGORITHMS.CLUSTER_WISE_STANDARD && Object.keys(fillFormData.parameters || {}).length === 0)) &&
        validateResourceSequenceBasedOnFillFormAlgorithm(fillFormData);
};

export const validateIncludedLocationsForDynamicCycle = (commonFormData) => {
    const includedLocationOptions = Object.values(commonFormData.includedLocations || {})
        .filter((option) => Array.isArray(option) && option.length === 2);

    const isCustomIncluded = includedLocationOptions
        .filter((includedLocationOption) => includedLocationOption[0] === INCLUDED_LOCATION_OPTIONS.COMMON.CUSTOM)
        .every((includedLocationOption) => includedLocationOption[1] && includedLocationOption[1].trim().length > 0);

    return includedLocationOptions.length === 2 && isCustomIncluded;
};
